import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import { LOCALE_PREFIX_SIGNALS as LOCALE_PREFIX } from '../../../../../Blocks/SyntheticIndicators/constants'
import { SIGNALS_WITH_TOGGABLE_FLAG } from '../../../../constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
export default class EntityFlags extends Component {
    static propTypes = {
        block: PropTypes.string,
        customData: PropTypes.object,
        flags: PropTypes.array,
        mainId: PropTypes.string,
        module: PropTypes.string,
        toggledFlags: PropTypes.object,
        toggleSignalFlag: PropTypes.func,
        type: PropTypes.string,
    }

    handleToggleSignalFlag = () => {
        const { module, block, customData, type, mainId, toggleSignalFlag } = this.props

        const flagOpen = !!customData?.toggledFlags?.[type]
        const newCustomData = {
            ...customData,
            toggledFlags: {
                ...customData.toggledFlags,
                [type]: !flagOpen,
            },
        }

        toggleSignalFlag(module, mainId, block, newCustomData)
    }

    render() {
        const { flags, type, toggledFlags } = this.props

        if (!flags) return null

        return (
            <div className={'subject-entity-flag'}>
                {flags.map((flag, idx) =>
                    SIGNALS_WITH_TOGGABLE_FLAG.includes(type) ? (
                        <div key={idx} className={'signal-entity-flag'}>
                            <div
                                onClick={this.handleToggleSignalFlag}
                                className={cx(
                                    'signal-entity-flag-title',
                                    !toggledFlags?.[type] ? 'collapse' : 'expand'
                                )}
                            >
                                <FormattedMessage id={`${LOCALE_PREFIX}.${type}.flagTitle`} />
                            </div>
                            {toggledFlags?.[type] && <div className={'flag-content'}>{flag}</div>}
                        </div>
                    ) : (
                        <div key={idx} className={'signal-entity-flag'}>
                            {flag}
                        </div>
                    )
                )}
            </div>
        )
    }
}
